<template>
  <SfNavigationCarousel
    :previous-action="previousAction"
    :next-action="nextAction"
  >
    <div class="sf-btn-bar-item tw-flex">
      <SfWorkflowStatusDropdown
        :align-option="alignOptions.LEFT"
        :available-statuses="statuses"
        :dropdown-id="dropdowns.RECONCILIATION_CAROUSEL"
        :ledger-id="ledgerId"
        :selected-status="selectedStatus"
        :workflow-id="workflowId"
        :is-inside-other-input="true"
        variant="seamless"
        @item-clicked="(item) => handleItemClick(item)"
      />
    </div>
  </SfNavigationCarousel>
</template>

<script setup lang="ts">
import type { WorkflowFilterStatus } from '@app/shared/types/sf-data'
import { isWorkflowStatus } from '@app/shared/vue/components/molecules/sf-workflow-status-dropdown/predicates'

import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { alignOptions, dropdowns } from '@app/shared/types/dropdown'
import SfWorkflowStatusDropdown from '@app/shared/vue/components/molecules/sf-workflow-status-dropdown/sf-workflow-status-dropdown.vue'
import SfNavigationCarousel from '@app/shared/vue/components/sf-carousel/sf-carousel-navigation.vue'

import { useWorkflowReviewFilter } from '@app/application/workflows/screens/workflow-review/store/pinia/workflow-review-filter'

interface Props {
  ledgerId: number
  previousAction: string
  nextAction: string
  statuses: WorkflowFilterStatus[]
  workflowId: number
}

defineProps<Props>()

const filterStore = useWorkflowReviewFilter()

const { filter } = storeToRefs(filterStore)
const { applyFilter } = filterStore

const selectedStatus = computed<WorkflowFilterStatus>(() => {
  return filter.value && isWorkflowStatus(filter.value)
    ? filter.value
    : 'show-all'
})

async function handleItemClick(param: WorkflowFilterStatus) {
  await applyFilter(param)
  window.eventHub.$emit('sf-left-overview-navigation:reload')
}
</script>
